<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Pre-Quote Sign-Off</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRiple icon="pi pi-search" title="Back to Search"
                                        class="p-button p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <!-- <p-tabView  [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Customer Details"> -->
                        <form [formGroup]="_Signoffform">
                            <table class="normal-table">

                                <tr>

                                    <td style="width:17%" class="text-right">
                                        Temp Customer <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <form [formGroup]="_Tempsignform">

                                            <div class="p-inputgroup">

                                                <input type="text" disabled formControlName="tempcustomer" pInputText>
                                                <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                                    (click)="showBasicDialog()">
                                                    <i class="las la-search"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </td>
                                    <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                    <td>
                                        <form [formGroup]="_Tempsignform">
                                            <input type="text" disabled formControlName="tempcustomersite" pInputText>
                                        </form>
                                    </td>
                                    <td class="text-right">Signed Contract<span class="hlt-txt">*</span></td>
                                    <td>
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <div class="browse-links">
                                                    <a href="javascript:void(0)" (click)="OpenSignOffImage()">
                                                        <p-button label="Image" styleClass="p-button-link"
                                                            title="{{imageselect}}">
                                                        </p-button>
                                                    </a>
                                                </div>
                                            </span>
                                            <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                                pTooltip="Browse File" tooltipPosition="top" mode="basic" #document
                                                accept="image/*,.pdf,.xlsx,.xls,.xlsm,.docx,.txt" [auto]="true"
                                                (onSelect)="SignoffDocumentSelect($event,document)">
                                            </p-fileUpload>

                                            <button class="p-inputgroup-addon p-button" pTooltip="Cancel" type="button"
                                                (click)="onDocumentClear()" tooltipPosition="top">
                                                <i class="pi pi-times"></i>
                                            </button>
                                        </div>
                                        <span class="text-danger" *ngIf="(_submittedimage)">
                                            * Max Allowable file size 3 MB
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">Cut off Day for Signed Contract <span
                                            class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <p-calendar [showIcon]="true" formControlName="cutoffdateforsignedcontract"
                                        [disabled]="disabledate" inputId="icon"></p-calendar>
                                    </td>
                                    <td class="text-right">Customer LR Copy Required <span class="hlt-txt">*</span>
                                    <td>
                                        <div class="p-formgroup-inline">
                                            <div class="p-field-radiobutton" *ngFor="let PF of _IsSpecialDelivery">
                                                <p-radioButton name="lrcopyrequired" value="M"
                                                    label={{PF.metasubdescription}}
                                                    (onClick)="GetInvoiceConfigurations(PF.metasubcode)"
                                                    formControlName="lrcopyrequired" value={{PF.metasubcode}}>
                                                </p-radioButton>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-right">Invoice Configuration</td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                            [options]="_InvoiceConfigurations" optionValue="metasubcode"
                                            [disabled]="disableInvoice" formControlName="invoiceconfiguration"
                                            optionLabel="metasubdescription">
                                        </p-dropdown>
                                    </td>
                                    <!-- [disabled]="disabledate" -->
                                </tr>
                                <tr>
                                    <td class="text-right">GST Applicable </td>
                                    <td>
                                        <p-checkbox formControlName="gstapplicable" binary="true" inputId="binary">
                                        </p-checkbox>
                                    </td>
                                    <td class="text-right">Job Order Date </td>
                                    <td>
                                        <p-checkbox formControlName="joborderdate" binary="true" inputId="binary">
                                        </p-checkbox>
                                    </td>
                                    <td class="text-right">Is E-Waybill Mandatory <span
                                        class="hlt-txt">*</span></td>
                                    <td>
                                        <p-checkbox formControlName="isewaybillmandatory" disabled="true" binary="true"
                                            inputId="binary">
                                        </p-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">Waybill print - Total Amount </td>
                                    <td>
                                        <p-checkbox formControlName="waybilltotalamount" binary="true" inputId="binary">
                                        </p-checkbox>
                                    </td>
                                    <td class="text-right">Waybill print - Splitup Amount </td>
                                    <td>
                                        <p-checkbox formControlName="waybillsplitupamount" binary="true"
                                            inputId="binary">
                                        </p-checkbox>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </form>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Special Delivery for Customer</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <!--  -->
                        <form [formGroup]="_Signoffform">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Is Special Delivery <span class="hlt-txt">*</span>
                                    <td>
                                        <div class="p-formgroup-inline">
                                            <div class="p-field-radiobutton" *ngFor="let PF of _IsSpecialDelivery">
                                                <p-radioButton name="isspecialdelivery" value="M"
                                                    label={{PF.metasubdescription}}
                                                    (onClick)="GetSpecial(PF.metasubcode)"
                                                    formControlName="isspecialdelivery" value={{PF.metasubcode}}>
                                                </p-radioButton>
                                            </div>
                                        </div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </form>
                        <form [formGroup]="_ServiceLocationAndOperation_SpecialDelivery_Form">
                            <table class="normal-table" *ngIf="DisableSpecial">
                                <tr>
                                    <td class="text-right">Special Delivery <span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                            [options]="_SpecialDelivery" formControlName="SpecialDeliverytypecode"
                                            optionValue="metasubcode" optionLabel="metasubdescription">
                                        </p-dropdown>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('SpecialDeliverytypecode').errors?.ServiceLocationsRequired">
                                            Please Select Special Delivery
                                        </span>
                                    </td>
                                    <td class="text-right">Attachment<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input name="file-upload-field" type="file" #takeInput
                                            (change)="selectFile($event)" class="file-upload-field"
                                            placeholder="Upload file"
                                            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                    </td>
                                    <td colspan="2">
                                        <button pButton label="Validate Uploaded Data" (click)="upload()"
                                            [disabled]=ValidateSpecial class="p-button-success"></button>
                                        <a href="assets/Docs/Special Delivery.xlsx" class="download-link">Download
                                            Template</a>

                                    </td>

                                </tr>


                                <tr>
                                    <td class="text-right">Consignee Name <span class="hlt-txt">*</span>
                                    </td>
                                    <td><input type="text" formControlName="ContactPerson" maxlength="50" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('ContactPerson').errors?.ServiceLocationsRequired">
                                            Please Enter the Consignee Name
                                        </span>
                                    </td>
                                    <td class="text-right">Mobile No. <span class="hlt-txt">*</span></td>
                                    <td><input type="text" formControlName="MobileNo"
                                            (keypress)="keypress.kpMobileNumber($event)" maxlength="10" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('MobileNo').errors?.ServiceLocationsRequired">
                                            Please Enter the Mobile No.
                                        </span>
                                    </td>
                                    <td class="text-right">Email ID <span class="hlt-txt">*</span></td>
                                    <td><input type="text" formControlName="EmailID" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('EmailID').errors?.EmailIDRequired">
                                            Please Enter Email ID
                                        </span>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted || _ServiceLocationAndOperation_SpecialDelivery_Form.get('EmailID').touched) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('EmailID').errors?.ValidEmailID">
                                            Please enter valid email ID
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">Address <span class="hlt-txt">*</span></td>

                                    <td><input type="text" formControlName="Address" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('Address').errors?.ServiceLocationsRequired">
                                            Please Enter the Address
                                        </span>
                                    </td>
                                    <td class="text-right">PinCode <span class="hlt-txt">*</span></td>
                                    <td><input type="text" formControlName="PinCode" (keyup)="enterpincodeSL($event)"
                                            pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('PinCode').errors?.ServiceLocationsRequired">
                                            Please Enter the PinCode
                                        </span>
                                    </td>
                                    <td class="text-right">Pincode Location<span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" formControlName="PincodeLocation"
                                            placeholder="Select" [filter]="true" [options]="TempSLpincodelocation"
                                            optionValue="pincodeLocation" optionLabel="pincodeLocation">
                                        </p-dropdown>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('PincodeLocation').errors?.ServiceLocationsRequired">
                                            Please Select Pincode Location
                                        </span>
                                    </td>
                                </tr>
                                <tr>

                                    <td class="text-right">Floor<span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" placeholder="Select"
                                            formControlName="Floor" [filter]="true" [options]="_SLFloorType"
                                            optionValue="metasubcode" optionLabel="metasubdescription">
                                        </p-dropdown>
                                        <span class="text-danger"
                                            *ngIf="(_SLSpecialDeliverysubmitted) && _ServiceLocationAndOperation_SpecialDelivery_Form.get('Floor').errors?.ServiceLocationsRequired">
                                            Please Select Floor
                                        </span>
                                    </td>

                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-center">
                                        <button pButton label="Add" class="p-button-success"
                                            (click)="AddSpecialDelivery()"></button>
                                        <button pButton label="Clear" class="p-button-warning"
                                            (click)="ClearSpecialDelivery()"></button>
                                    </td>
                                </tr>
                            </table>
                        </form>
                        <div class="card" *ngIf="DisableSpecial">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom" (click)="exportExcel()"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="SpecialDeliveryList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['SpecialDeliverytype','ContactPerson','MobileNo','EmailID','Address','Floortype']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                                    <colgroup>
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:150px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width: 100px">
                                                        <col style="width:150px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                        <col style="width:250px">
                                                    </colgroup>
                                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;" style="width: 6%;">Action</th>

                                        <th pSortableColumn="SpecialDeliverytype" style="width: 12%;">
                                            Special Delivery<p-sortIcon field="SpecialDeliverytype">
                                            </p-sortIcon>
                                        </th>

                                        <th pSortableColumn="ContactPerson" style="width: 12%;">Consignee Name
                                            <p-sortIcon field="ContactPerson">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="MobileNo" style="width: 9%;">Mobile No <p-sortIcon
                                                field="MobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="EmailID" style="width: 8%;">Email ID <p-sortIcon
                                                field="EmailID">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="Address" style="width: 8%;">Address <p-sortIcon
                                                field="Address">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="Floortype" style="width: 7%;">Floor <p-sortIcon
                                                field="Floortype">
                                            </p-sortIcon>
                                        </th>
                                        <!--th pSortableColumn="mobileNo"  style="width: 7%;">State <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo"  style="width: 6%;">City <p-sortIcon field="mobileNo"></p-sortIcon>
                                                </th-->
                                        <th pSortableColumn="PinCode" style="width: 8%;">PinCode <p-sortIcon
                                                field="PinCode">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="PincodeLocation" style="width: 13%;">Pincode
                                            Location <p-sortIcon field="PincodeLocation">
                                            </p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="mobileNo">State <p-sortIcon field="mobileNo"></p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th>
                                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                            </p-sortIcon>
                                                        </th> -->
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList let-i="rowIndex">
                                    <tr>
                                        <td>
                                            <!-- <button pButton pRipple title="Add" icon="pi pi-plus"
                                                                class="p-button-success p-mr-2" 
                                                                ></button> -->
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"
                                                (click)="RemoveVariant(_ManageCustomerList)"
                                                [disabled]="_action=='view'"></button>
                                        </td>

                                        <td>
                                            {{_ManageCustomerList.SpecialDeliverytype}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.contactPerson}}
                                        </td>

                                        <td>
                                            {{_ManageCustomerList.MobileNo}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.EmailID}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.Address}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.Floortype}}
                                        </td>
                                        <!--td>
                                                    {{_ManageCustomerList.billingcycle}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.status}}
                                                </td-->
                                        <td>
                                            {{_ManageCustomerList.pincode}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.PincodeLocation}}
                                        </td>
                                        <!-- <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td>
                                                        <td>
                                                            {{_ManageCustomerList.mobileNo}}
                                                        </td> -->
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Contact Details</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <p-tabView [(activeIndex)]="Contactselectedtab">

                            <p-tabPanel header="Invoice to be Submitted To">
                                <form [formGroup]="_CustomerContactInvoiceform">
                                    <table class="normal-table">
                                        <tr>
                                            <td class="text-right">Contact Person Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="contactperson" maxlength="50"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactInvoiceform.get('contactperson').errors?.CustomersiteRequired">
                                                    Please enter Contact Person Name
                                                </span>
                                            </td>
                                            <td class="text-right">Designation <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="designation" maxlength="30"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactInvoiceform.get('designation').errors?.CustomersiteRequired">
                                                    Please enter Designation
                                                </span>
                                            </td>
                                            <!-- <td class="text-right">Pin code Location <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText> </td> -->
                                            <td class="text-right">Department<span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="department" maxlength="30"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactInvoiceform.get('department').errors?.CustomersiteRequired">
                                                    Please enter Department
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="text-right">Phone No.
                                            </td>
                                            <td><input type="text" formControlName="phoneno"
                                                    (keypress)="keypress.kpMobileNumber($event)" maxlength="15"
                                                    pInputText>

                                            </td>
                                            <td class="text-right">Mobile No. +91 <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="mobileno"
                                                    (keypress)="keypress.kpMobileNumber($event)" maxlength="10"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactInvoiceform.get('mobileno').errors?.CustomersiteRequired">
                                                    Please enter Mobile No
                                                </span>
                                            </td>
                                            <td class="text-right">Email Id<span class="hlt-txt">*</span></td>
                                            <td><input type="text" formControlName="emailid" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactInvoiceform.get('emailid').errors?.EmailIDRequired">
                                                    Please Enter Email ID
                                                </span>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted || _CustomerContactInvoiceform.get('emailid').touched) && _CustomerContactInvoiceform.get('emailid').errors?.ValidEmailID">
                                                    Please enter valid email ID
                                                </span>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                        <td class="text-right">Fax No
                                        </td>
                                        <td><input type="text" formControlName="faxno"
                                                (keypress)="keypress.kpMobileNumber($event)"
                                                maxlength="20" pInputText>

                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> -->
                                    </table>
                                </form>
                            </p-tabPanel>
                            <p-tabPanel header="Outstanding Mail to be submitted To">
                                <form [formGroup]="_CustomerContactOutgoingform">
                                    <table class="normal-table">
                                        <tr>
                                            <td class="text-right">Contact Person Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="contactperson" maxlength="50"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactOutgoingform.get('contactperson').errors?.CustomersiteRequired">
                                                    Please enter Contact Person Name
                                                </span>
                                            </td>
                                            <td class="text-right">Designation <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="designation" maxlength="30"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactOutgoingform.get('designation').errors?.CustomersiteRequired">
                                                    Please enter Designation
                                                </span>
                                            </td>
                                            <!-- <td class="text-right">Pin code Location <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText> </td> -->
                                            <td class="text-right">Department<span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="department" maxlength="30"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactOutgoingform.get('department').errors?.CustomersiteRequired">
                                                    Please enter Department
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="text-right">Phone No.
                                            </td>
                                            <td><input type="text" formControlName="phoneno"
                                                    (keypress)="keypress.kpMobileNumber($event)" maxlength="15"
                                                    pInputText>

                                            </td>
                                            <td class="text-right">Mobile No. +91 <span class="hlt-txt">*</span>
                                            </td>
                                            <td><input type="text" formControlName="mobileno"
                                                    (keypress)="keypress.kpMobileNumber($event)" maxlength="10"
                                                    pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactOutgoingform.get('mobileno').errors?.CustomersiteRequired">
                                                    Please enter Mobile No
                                                </span>
                                            </td>
                                            <td class="text-right">Email Id<span class="hlt-txt">*</span></td>
                                            <td><input type="text" formControlName="emailid" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted) && _CustomerContactOutgoingform.get('emailid').errors?.EmailIDRequired">
                                                    Please Enter Email ID
                                                </span>
                                                <span class="text-danger"
                                                    *ngIf="(_submitted || _CustomerContactOutgoingform.get('emailid').touched) && _CustomerContactOutgoingform.get('emailid').errors?.ValidEmailID">
                                                    Please enter valid email ID
                                                </span>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                        <td class="text-right">Fax No
                                        </td>
                                        <td><input type="text" formControlName="faxno"
                                                (keypress)="keypress.kpMobileNumber($event)"
                                                maxlength="20" pInputText>

                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>                                                         -->
                                    </table>
                                </form>
                            </p-tabPanel>
                        </p-tabView>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments History </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <p-table #dt [value]="_ApprovalComment" [rows]="10" [paginator]="true"
                            [rowsPerPageOptions]="[10,25,50,100]"
                            [globalFilterFields]="['flatodachargefrom','flatodachargeto']" [rowHover]="true"
                            dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [showCurrentPageReport]="true" [scrollable]="true">
                            <ng-template pTemplate="colgroup" let-columns>
                                <colgroup>
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <!--  <col style="width:150px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">-->
                                </colgroup>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <!-- <th style="text-align: center;width: 100px;" rowspan="2">Action</th> -->
                                    <th pSortableColumn="flatodachargefrom">Comments<p-sortIcon
                                            field="flatodachargefrom">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodachargeto">Role Name <p-sortIcon field="flatodachargeto">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">User Name<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">Date & Time<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">Status<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>

                                    <!-- <th pSortableColumn="agentName">Effective From <p-sortIcon field="agentName">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="agentName">Effective To <p-sortIcon field="agentName">
                    </p-sortIcon>
                </th> -->

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-_KGListGrid let-i="rowIndex">
                                <tr>
                                    <!-- <td style="text-align: center">
        
        <button pButton pRipple title="Remove"
            (click)="Remove_KGListWayBill(_KGListGrid)" icon="pi pi-trash"
            class="p-button-danger p-mr-2"></button>
    </td> -->
                                    <td>
                                        {{_KGListGrid.approvalComments}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approverRoleName}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approverUserName}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.createdon | date:'dd/MM/yyyy HH:ss'}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approversStatus}}
                                    </td>

                                    <!-- <td>
                    {{_agentListGrid.agentName}}
                </td>
                <td>
                    {{_agentListGrid.agentName}}
                </td> -->

                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <form [formGroup]="_Signoffform">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Comments<span class="hlt-txt">*</span></td>
                                    <!-- <td> -->
                                    <td colspan="5"><textarea inputId="textarea"
                                            formControlName="prequotesignoffcomments" rows="2" cols="30"
                                            pInputTextarea></textarea>
                                        <span class="text-danger"
                                            *ngIf="(_submitted) && _Signoffform.get('prequotesignoffcomments').errors?.CustomersiteRequired">
                                            Please enter Comments
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-center">
                                        <button pButton label="Save" (click)="onSavesignoff()" class="p-button-success"
                                            icon="las la-check"></button>
                                        <!-- <button pButton label="Clear" class="p-button-warning" (click)="Clearsignoff()"
                                            icon="las la-broom"></button> -->
                                    </td>
                                </tr>

                            </table>
                        </form>
                        <div #editor style="width: 500px;height: 250px; overflow-y:auto;"></div>
                        <p-dialog header="Customer" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="_CustomerApprovedList" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                            (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                                </th> -->
                                                    <th pSortableColumn="customername">Customer Name <p-sortIcon
                                                            field="customername">
                                                        </p-sortIcon>
                                                    </th>
                                                    <!-- <th pSortableColumn="requestedbranch">Customer Tally ID
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th> -->
                                                    <th pSortableColumn="customersitename">Customer Site Name
                                                        <p-sortIcon field="customersitename">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="istransporter">Is Transporter
                                                        <p-sortIcon field="istransporter">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="billingcycle">Billing Cycle
                                                        <p-sortIcon field="billingcycle">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="pan">Pan No
                                                        <p-sortIcon field="pan">
                                                        </p-sortIcon>
                                                    </th>


                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-CustomerApproved>
                                                <tr [pSelectableRow]="rowData">
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                                </td> -->
                                                    <td>{{CustomerApproved.customername}}</td>
                                                    <td>{{CustomerApproved.customersitename}}</td>
                                                    <!-- <td>{{_Expense.balanceamount}}</td> -->
                                                    <td>{{CustomerApproved.istransporter}}</td>
                                                    <td>{{CustomerApproved.billingcycle}}</td>
                                                    <td>{{CustomerApproved.pan}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                        <p-dialog #warning [style]="{width: '400px'}" header="Success"
                            [(visible)]="displaySuccessMSG" [modal]="true" [baseZIndex]="10000"
                            [draggable]="false" [resizable]="false" [closable]="false">
                            <ng-template pTemplate="content">
                                <label>Pre-Quote Sign Off Submitted Successfully</label>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <button type="button" pButton icon="las la-check" label="Ok" autofocus
                                    (click)="Ok()"></button>                            
                            </ng-template>
                        </p-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>